import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/adu-rental-income-california.png";

const BlogADURentalIncome = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "How ADUs Create Rental Income in California",
    "description": "Build for value, income, and flexibility. Learn how ADUs generate consistent rental income in California.",
    "datePublished": "2026-04-07",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/adu-rental-income-california" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />
      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="How ADUs create rental income in California" className="w-full rounded-2xl" />
      </div>
      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Blog
        </Link>
        <p className="text-sm text-muted-foreground mb-2">April 7, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">How ADUs Create Rental Income in California</h1>
        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>More homeowners are building ADUs for one reason. Income.</p>
          <p>In many parts of California, an ADU can generate consistent rental income and increase overall property value.</p>
          <p>But not every ADU performs the same.</p>
          <p>Layout, location on the lot, privacy, and design all affect how rentable the unit is.</p>
          <p>We guide homeowners through these decisions early. The goal is not just to build an ADU, but to build one that works financially.</p>
          <p>When done right, an ADU becomes a long-term asset.</p>
        </article>
        <BlogCTAButtons />
      </main>
      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogADURentalIncome;
